module.exports = __webpack_public_path__ + "static/assets/2e74abc852a93c9299a0c95491409689.svg";